import { useState } from 'react'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import { IFleetTreeData } from '~/models'
import styles from './FleetNav.module.scss'
import classNames from 'classnames/bind'
import { currentTheme } from '~/redux/features'
import { useAppSelector } from '../../app/hooks'
import { BpRadio } from '../EFRadioGroup'
import { IFleetNavItemProps } from './FleetButton.model'

const cx = classNames.bind(styles)

const FleetNavItems = function ({
  fleet,
  selectedFleetId,
  searching,
  disabled,
  depthLevel,
  onClick
}: IFleetNavItemProps) {
  function fleetHasChild(searchFleet: IFleetTreeData, searchId: string): boolean {
    let match: boolean = false
    for (let child of searchFleet.childrenFleet) {
      if (child.id === searchId) {
        match = true
        break
      } else {
        match = fleetHasChild(child, searchId)
      }
    }
    return match
  }
  const actionExpanded =
    depthLevel === 0 || searching || fleetHasChild(fleet, selectedFleetId)
  const [userExpanded, setUserExpanded] = useState<boolean>(false)

  function handleExpandToggleClick() {
    setUserExpanded(!userExpanded)
  }

  const expandedStateClass = userExpanded || actionExpanded ? '' : 'invisible'
  const childClass = fleet?.childrenFleet?.length > 0 ? 'has-children' : '';
  const theme = useAppSelector(currentTheme)

  return (
    <div className={cx('fleet', expandedStateClass, childClass)}>
      {fleet?.childrenFleet?.length > 0 ? (
        <button
          disabled={disabled}
          type='button'
          className={`${theme}`}
          onClick={handleExpandToggleClick}
        >
          <KeyboardArrowDownOutlinedIcon />
        </button>
      ) : null}
      <label>
        <BpRadio
          disabled={disabled}
          name={'fleet'}
          value={fleet.id}
          checked={fleet.id === selectedFleetId}
          onChange={onClick}
        />
        {fleet.name}
      </label>

      {fleet?.childrenFleet?.map(currentFleet => {
        return (
          <FleetNavItems
            fleet={currentFleet}
            selectedFleetId={selectedFleetId}
            onClick={onClick}
            searching={searching}
            depthLevel={depthLevel + 1}
            key={currentFleet.id}
            disabled={disabled}
          />
        )
      })}
    </div>
  )
}

export default FleetNavItems
